var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconExchange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 607.13 607.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".n{fill:url(#m);}.o{mask:url(#g);}.p{mask:url(#i);}.q,.r,.s,.t,.u{fill:none;}.r{stroke:#fff;stroke-width:3px;}.r,.s,.t,.u{stroke-miterlimit:10;}.s{stroke:url(#d);}.s,.u{stroke-width:1.2px;}.v{fill:#fff;}.w{fill:#dbf0fb;}.t{opacity:.69;stroke:url(#c);stroke-width:1.17px;}.x,.y{mix-blend-mode:multiply;}.a`{filter:url(#k);}.y{fill:#afb1b4;opacity:.53;}.u{opacity:.38;stroke:url(#b);}.aa{clip-path:url(#f);}.ab{clip-path:url(#e);}.ac{clip-path:url(#j);}.ad{clip-path:url(#h);}.ae{isolation:isolate;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -2182.14,
    y1: -502.3,
    x2: -1643.88,
    y2: -502.3,
    gradientTransform: "translate(-202.05 2213.48) rotate(90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -873.09,
    y1: -559.29,
    x2: -407.15,
    y2: -559.29,
    gradientTransform: "translate(-259.04 940.59) rotate(90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#fff",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#fff",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#fff",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#fff",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#fff",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -1972.25,
    y1: 2570.73,
    x2: -1578.55,
    y2: 2570.73,
    gradientTransform: "translate(-2270.47 -1474.93) rotate(-90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "q",
    x: 177.54,
    y: 177.76,
    width: 245.42,
    height: 245.42
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "q",
    x: 177.54,
    y: 177.76,
    width: 245.42,
    height: 245.42
  })), /*#__PURE__*/React.createElement("mask", {
    id: "g",
    x: 136.64,
    y: 145.95,
    width: 327.22,
    height: 281.77,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M300.25,423.18c67.77,0,122.71-54.94,122.71-122.71s-54.94-122.71-122.71-122.71-122.71,54.94-122.71,122.71,54.94,122.71,122.71,122.71"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "q",
    x: 136.64,
    y: 145.95,
    width: 327.22,
    height: 281.77
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "q",
    x: 136.64,
    y: 145.95,
    width: 327.22,
    height: 287.96
  })), /*#__PURE__*/React.createElement("mask", {
    id: "i",
    x: 136.64,
    y: 145.95,
    width: 327.22,
    height: 287.96,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ac"
  }, /*#__PURE__*/React.createElement("image", {
    transform: "translate(136.64 145.95) scale(2.18)",
    xlinkHref: "data:image/png;base64,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"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "k",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.16,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "l",
    stdDeviation: 1.74
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#75a9bb",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "l",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 269.34,
    y1: 330.7,
    x2: 356.65,
    y2: 250.99,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#385ba4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090cf"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "ae"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "w",
    cx: 300.25,
    cy: 300.47,
    rx: 162.51,
    ry: 159.21
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "v",
    cx: 300.25,
    cy: 300.47,
    rx: 125.25,
    ry: 122.71
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "u",
    cx: 300.25,
    cy: 300.47,
    rx: 264.55,
    ry: 268.53
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "t",
    cx: 300.25,
    cy: 300.47,
    rx: 228.41,
    ry: 232.39,
    transform: "translate(-124.52 300.32) rotate(-45)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "s",
    cx: 300.25,
    cy: 300.47,
    rx: 192.27,
    ry: 196.25,
    transform: "translate(-124.52 300.32) rotate(-45)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "x"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ab"
  }, /*#__PURE__*/React.createElement("g", {
    className: "aa"
  }, /*#__PURE__*/React.createElement("g", {
    className: "o"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ad"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M300.25,423.18c67.77,0,122.71-54.94,122.71-122.71s-54.94-122.71-122.71-122.71-122.71,54.94-122.71,122.71,54.94,122.71,122.71,122.71"
  }), /*#__PURE__*/React.createElement("g", {
    className: "p"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "y",
    x: 136.64,
    y: 145.95,
    width: 327.22,
    height: 287.96
  }))))))), /*#__PURE__*/React.createElement("g", {
    className: "a`"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M246.85,373.69v-26.48c0-10.2,8.47-18.5,18.88-18.5h68.46c4.53,0,8.21,3.61,8.21,8.04v11.09h-76.01v6.7h79.07c5.52,0,10.01-4.4,10.01-9.81v-12.92c0-5.41-4.49-9.81-10.01-9.81h-119.94v-7.1c0-6.64,5.51-12.04,12.29-12.04h107.65c16.29,0,29.55,12.99,29.55,28.95v12.92c0,15.96-13.25,28.95-29.55,28.95h-98.6Zm-9.05-75.63c-6.77,0-12.29-5.4-12.29-12.04v-7.1h119.94c5.52,0,10.01-4.4,10.01-9.81v-12.92c0-5.41-4.49-9.81-10.01-9.81h-79.07v6.7h76.01v11.09c0,4.44-3.68,8.04-8.21,8.04h-68.46c-10.41,0-18.88-8.3-18.88-18.5v-26.48h98.6c16.29,0,29.55,12.99,29.55,28.95v12.92c0,15.96-13.25,28.95-29.55,28.95h-107.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M373.38,256.19v12.92c0,15.11-12.51,27.36-27.93,27.36h-107.65c-5.89,0-10.67-4.68-10.67-10.45v-5.52h118.32c6.42,0,11.63-5.1,11.63-11.4v-12.92c0-6.29-5.21-11.4-11.63-11.4h-80.68v9.87h76.01v9.51c0,3.57-2.95,6.46-6.59,6.46h-68.46c-9.53,0-17.26-7.57-17.26-16.91v-24.89h96.98c15.43,0,27.93,12.25,27.93,27.36Zm0,88.55v-12.92c0-15.11-12.51-27.36-27.93-27.36h-107.65c-5.89,0-10.67,4.68-10.67,10.45v5.52h118.32c6.42,0,11.63,5.1,11.63,11.4v12.92c0,6.29-5.21,11.4-11.63,11.4h-80.68v-9.87h76.01v-9.51c0-3.57-2.95-6.46-6.59-6.46h-68.46c-9.53,0-17.26,7.57-17.26,16.91v24.89h96.98c15.43,0,27.93-12.25,27.93-27.36Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "r",
    cx: 300.25,
    cy: 300.47,
    rx: 125.25,
    ry: 122.71
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExchange);
export default __webpack_public_path__ + "static/media/iconExchange.da29ef6477d800521dc18d4966735607.svg";
export { ForwardRef as ReactComponent };